module.exports = __webpack_public_path__ + "img/top.f90872c9.png";